import { render, staticRenderFns } from "./longread6.vue?vue&type=template&id=57a5308e&"
import script from "./longread6.vue?vue&type=script&lang=js&"
export * from "./longread6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports